export default __webpack_public_path__ + "static/media/37.167b2682.jpg";